module.exports = __webpack_public_path__ + "officialStatic/img/xPartner-bg.6810bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/xPartner-bg.png
// module id = 7nDQ
// module chunks = 0